import styles from '../Tabelas.module.css'
import Container from '../../../../components/components-ui/Container/Container'
import Button from '../../../../components/components-ui/Button/Button'
import { Grid, Col } from '../../../../components/Grid'
import api from '../../../../services/Api'
import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'
import 'react-toastify/dist/ReactToastify.css'
import { toast } from 'react-toastify'
import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'

function Action() {
  const { id } = useParams()
  const [tipoLogradouro, setTipoLogradouro] = useState('')

  function showAlert(notify, msg) {
    if (notify === 0) {
      toast.success(msg, {autoClose: 2500})
    } else {
      toast.error(msg)
    }
  }

  async function createTipoLogradouro(values) {
    const response = await api.post('/logradourotipo/create/', {
      tipo_logradouro: values.tipoLogradouro,
    })
    if (response.data.error === 0) {
      showAlert(0, response.data.msg)
      navigate("/usina/brinde")
      return
    }
    showAlert(1, response.data.msg)
  }

  async function editarTipoLogradouro(values) {
    const response = await api.put(`/logradourotipo/edit/${id}`, {
      tipo_logradouro: values.tipoLogradouro,
    })
    if (response.data.error === 0) {
      showAlert(0, response.data.msg)
      navigate("/usina/brinde")
      return
    }
    showAlert(1, response.data.msg)
  }

  useEffect(() => {
    if (id) {
      async function getTipoLogradouro() {
        const response = await api.get(`/logradourotipo/show/${id}`)
        setTipoLogradouro(response.data.TipoLogradouro)
      }
      getTipoLogradouro()  
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const navigate = useNavigate()
  const validadtionSchema = Yup.object().shape({
    tipoLogradouro: Yup.string().required('*Campo Obrigatório'),
  })
  return (
    <Container>
      <h3>
        {id ? 'Edição de Tipo de Logradouro' : 'Cadastro de Tipo de Logradouro'}
      </h3>
      <section className={styles.action_section}>
        <Formik
          enableReinitialize={true}
          initialValues={{ tipoLogradouro: tipoLogradouro }}
          onSubmit={
            id
              ? (values) => editarTipoLogradouro(values)
              : (values) => createTipoLogradouro(values)
          }
          validationSchema={validadtionSchema}
        >
          {({ errors, touched }) => (
            <Form>
              <Grid>
                <Col size={12}>
                  <label> Tipo Logradouro </label>
                  <Field type="text" name="tipoLogradouro" />
                  {errors.tipoLogradouro && touched.tipoLogradouro ? (
                    <span className={styles.alertError}>
                      {errors.tipoLogradouro}
                    </span>
                  ) : null}
                </Col>
              </Grid>
              <Grid>
                <Col size={12}>
                  <Button type="submit" title={'Salvar'} />
                  <Button
                    type="button"
                    title="Voltar"
                    color="secondary"
                    onClick={() => {
                      navigate('/usina/tipo-logradouro')
                    }}
                  />
                </Col>
              </Grid>
            </Form>
          )}
        </Formik>
      </section>
    </Container>
  )
}

export default Action
